import { axiosInstance } from "@/lib/axios";
import queryClient from "@/lib/queryClient";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { z } from "zod";

export const BlogCategorySchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const CreateBlogCategorySchema = z.object({
  name: z.string().min(1),
});

export type BlogCategoryType = z.infer<typeof BlogCategorySchema>;
export type CreateBlogCategoryType = z.infer<typeof CreateBlogCategorySchema>;

// API functions
export async function getBlogCategoriesFn() {
  return (await axiosInstance.get<BlogCategoryType[]>("/api/blog-categories"))
    .data;
}

export async function createBlogCategoryFn(data: CreateBlogCategoryType) {
  return (
    await axiosInstance.post<BlogCategoryType>("/api/blog-categories", data)
  ).data;
}

const BlogCategory = {
  Get: {
    useQuery: (options = {}) =>
      useQuery({
        queryKey: ["BlogCategories"],
        queryFn: () => getBlogCategoriesFn(),
        ...options,
      }),
  },

  Create: {
    useMutation: (options = {}) =>
      useMutation({
        mutationFn: createBlogCategoryFn,
        onSuccess: (data) => {
          toast.success(`Category "${data.name}" created successfully`);
          queryClient.invalidateQueries({ queryKey: ["BlogCategories"] });
        },
        onError: (error: any) => {
          const message =
            error?.response?.data?.error || "Failed to create category";
          toast.error(message);
        },
        ...options,
      }),
  },
};

export default BlogCategory;
